import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AuthService } from '../auth/auth.service'
import { LoadingComponent } from '../shared/loading.component'
import { UsersService } from '../users/users.service'

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private usersService: UsersService) { }

  ngOnInit() {
    this.authService.getUser().subscribe(
      (success) => {
        this.usersService.profile.subscribe(
          (profile) => {
            if (profile.onlyQC) {
              this.router.navigate(["/qc_reports"])
            } else {
              this.router.navigate(["/home"])
            }
          },
          (error) => this.router.navigate(["/"])
        )
      },
      (error) => this.router.navigate(["/"])
    )
  }


}



// WEBPACK FOOTER //
// ./src/app/root/root.component.ts